<div
  class="flex w-full flex-col gap-2 sm:flex-row"
  [ngClass]="{ 'py-4': currentStepValidity() && !currentStepValidity()?.hideButtons }"
>
  @if (hasPreviousStep() && !currentStepValidity().hideButtons) {
    <button
      nxButton="secondary"
      class="grow"
      (click)="handlePreviousStep$.next()"
    >
      <div>
        <fa-icon [icon]="'chevron-left'" />
        <span>
          {{ "navigation-button.previous" | translate }}
        </span>
      </div>
    </button>
  }
  @if (hasNextStep() && !currentStepValidity().hideButtons) {
    <button
      [title]="
        currentStepValidity().message
          ? (currentStepValidity().message! | translate)
          : ''
      "
      nxButton="primary"
      class="grow"
      (click)="handleNextStep$.next()"
    >
      <div>
        <span>
          {{
            currentStepValidity().nextButtonTitle ?? "navigation-button.next"
              | translate
          }}
        </span>
        <fa-icon [icon]="'chevron-right'" />
      </div>
    </button>
  }
</div>
